import moment from 'moment';
import {
  useLazyGetDataReviewcrfSummaryGetAllQuery,
  useLazyGetDataReviewcrfSummaryQuery
} from 'src/services/SubjectTrackingDetails';

export const useSubjectTracking = () => {
  const [
    getDataReviewcrfSummary,
    {
      isLoading: isCRFSummaryLoading,
      isSuccess: isCRFSummarySuccess,
      data: crfSummaryData,
      isError: crfSummaryIsError,
      error: crfSummaryError
    }
  ] = useLazyGetDataReviewcrfSummaryQuery();

  const [
    getDataReviewcrfSummaryGetAll,
    {
      isLoading: isCRFSummaryGetAllLoading,
      isSuccess: isCRFSummaryGetAllSuccess,
      data: crfSummaryGetAllData,
      isError: crfSummaryGetAllIsError,
      error: crfSummaryGetAllError
    }
  ] = useLazyGetDataReviewcrfSummaryGetAllQuery();

  const sendBookMarkValue = (crfFormMetaData: any, bookmarkKey: any, renderingData: any) => {
    const formData = crfFormMetaData.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
    let returnVal = '';
    formData.map((metaData: any) => {
      if (bookmarkKey == metaData?.key) {
        if (
          metaData?.cmp == 'checkbox' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          if (renderingData[bookmarkKey] != null) {
            const valUesKeys = Object.keys(renderingData[bookmarkKey]);
            const checkBoxValues: any = [];
            valUesKeys.map((item: any) => {
              for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
                if (item == metaData?.data_dictionary_values[i].code_list_value_code) {
                  checkBoxValues.push(metaData?.data_dictionary_values[i].code_list_value);
                  break;
                }
              }
            });
            returnVal = checkBoxValues.toString();
          }
        } else if (
          metaData?.cmp == 'select' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          if (metaData?.multiple && renderingData[bookmarkKey] != null) {
            const multipleValueData = renderingData[bookmarkKey].key;
            const ddmValues: any = [];
            multipleValueData?.map((item: any) => {
              for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
                if (
                  item?.value == metaData?.data_dictionary_values[i].code_list_value_code ||
                  item?.code_list_value_code == metaData?.data_dictionary_values[i].code_list_value_code
                ) {
                  ddmValues.push(metaData?.data_dictionary_values[i].code_list_value);
                  break;
                }
              }
            });
            returnVal = ddmValues.toString();
          } else {
            if (renderingData[bookmarkKey] != null) {
              returnVal = renderingData[bookmarkKey].label;
            }
          }
        } else if (
          metaData?.cmp == 'radio' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
            if (renderingData[bookmarkKey] == metaData?.data_dictionary_values[i].code_list_value_code) {
              returnVal = metaData?.data_dictionary_values[i].code_list_value;
              break;
            }
          }
        } else if (metaData?.cmp == 'date' && metaData?.type == 'date_time' && renderingData[bookmarkKey] != null) {
          returnVal = moment(renderingData[bookmarkKey]).format('MM/DD/YYYY h:mm A');
        } else if (metaData?.cmp == 'date' && metaData?.type == 'date' && renderingData[bookmarkKey] != null) {
          returnVal = moment(renderingData[bookmarkKey]).format('MM/DD/YYYY');
        } else {
          returnVal = renderingData[bookmarkKey];
        }
      }
    });
    return returnVal;
  };

  return {
    isCRFSummaryLoading,
    isCRFSummarySuccess,
    crfSummaryData,
    crfSummaryIsError,
    crfSummaryError,
    getDataReviewcrfSummary,
    isCRFSummaryGetAllLoading,
    isCRFSummaryGetAllSuccess,
    crfSummaryGetAllData,
    crfSummaryGetAllError,
    crfSummaryGetAllIsError,
    getDataReviewcrfSummaryGetAll,
    sendBookMarkValue
  };
};
